import { useQuery } from '@tanstack/react-query';
import { userService } from '../services/userService';
import { USER_KEYS } from '../constants/queryKeys';
import { UserProfile } from '../types/user';

/**
 * Hook to fetch and manage the user's profile data using React Query.
 *
 * @returns The query result for the user profile
 */
export function useProfile() {
  return useQuery<UserProfile>({
    queryKey: USER_KEYS.profile(),
    queryFn: () => userService.getProfile(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
